import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_workplace_rules_comply_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'do_workplace_rules_comply_w_legal_reqs',
  name: 'Do workplace rules comply with legal requirements?',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nWorkplace rules (also known as "workplace code of conduct" or "worker code of conduct") lays out the facility\'s expectations for appropriate workplace behavior.\r\r\n\r\r\nWorkplace rules / internal regulations cannot contain provisions that are less favorable to workers than the law. In addition, applicable legal requirements should be consulted to determine whether provisions that relate specifically to workplace rules have been complied with (e.g., regarding contents, consultation process, language, etc.).\r\r\n\r\r\nAnswer Yes if workplace rules are in place as required and content of workplace rules is in line with applicable legal requirements. \r\r\n\r\r\nAnswer No if the facility either does not have workplace rules in place (and they are LEGALLY required) OR workplace rules do not meet legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-emp-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5910,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
